export enum BookingLoginReservationButtonSize {
    Normal = "normal",
    Small = "small",
    Large = "large",
}